"use client";

import { TimelineContainer } from "./timeline-container";
import { RailItineraryInner } from "./rail-itinerary-inner";
import { iRailLegDetails } from "@/@sdk/holiday-quotes-x/holiday-quotes-x-model";

export function RailItinerary(
  props: iRailLegDetails & { primaryColor?: string; day: number }
) {
  return (
    <TimelineContainer
      title={props.title || "Rail Journey"}
      icon={(props.icon as any) || "train"}
    >
      <RailItineraryInner {...props} day={props.day} />
    </TimelineContainer>
  );
}
